import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CommentIcon: React.FC<Props> = ({ color = theme.colors.text }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.6686 7.71117C14.6686 11.2333 11.6834 14.089 8.00193 14.089C7.56907 14.0896 7.1374 14.0495 6.7122 13.9697C6.40615 13.9122 6.25312 13.8834 6.14629 13.8998C6.03945 13.9161 5.88805 13.9966 5.58526 14.1576C4.72869 14.6132 3.7299 14.774 2.76934 14.5954C3.13443 14.1463 3.38377 13.6075 3.49379 13.0299C3.56045 12.6766 3.39527 12.3334 3.14786 12.0821C2.02415 10.941 1.33527 9.40344 1.33527 7.71117C1.33527 4.18909 4.32045 1.33337 8.00193 1.33337C11.6834 1.33337 14.6686 4.18909 14.6686 7.71117Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.99893 8H8.00493M10.6626 8H10.6686M5.33527 8H5.34125"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
